import React from 'react';
import AppRoutes from './router/AppRoutes';
import { HashRouter } from 'react-router-dom';
import ErrorBoundary from './ErrorBoundary';

function App() {

  return (
    <HashRouter>
      <ErrorBoundary >
      <AppRoutes />
      </ErrorBoundary>
    </HashRouter>
  );
}

export default App;
